// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__V7fdj","employee-header-item":"Header_employee-header-item__z2XA2"};